import React from 'react';

export default class Enfermo extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount(){}

  render(){
    const {show, editar, datos} = this.props;
    return(
      <div style={{display:'flex', flexDirection:'column', width:'100%'}}>
        <div style={{
          display:'flex', flexDirection:'row', width:'calc(100% - 30px)',
          padding:'10px 15px', backgroundColor:'#00b1e9', color:'white',
          fontSize:18, fontFamily:'Barlow_Condensed', fontWeight:'bold'
        }}>
          <strong>7. </strong> &nbsp;
          ¿Está cursando la enfermedad por COVID?
        </div>
        <div style={{
          display: show ? 'flex' : 'none',
          flexDirection:'column', width:'100%', margin:'10px 0'
        }}>
          <label style={{display:'block'}}>
            <input
              type="checkbox"
              style={{minWidth:30}}
              checked={datos.enfermo}
              onChange={(e) => editar('enfermo', e.target.checked)}
            />
            Si
          </label>
          <label style={{display:'block'}}>
            <input
              type="checkbox"
              style={{minWidth:30}}
              checked={!datos.enfermo}
              onChange={(e) => editar('enfermo', !e.target.checked)}
            />
            No
          </label>
          {datos.enfermo &&
            <span style={{margin:3}}>
              Recordar medidas generales de prevención y aislamiento
            </span>
          }
        </div>
      </div>
    )
  }
}
